export const useCasesCards = [
  {
    title: "Omnichannel Contact Centre Transformation",
    description:
      "Rapid migration or greenfield deployment of an AWS-native, omnichannel contact centre enabling organisations to quickly move from legacy/on-premise systems ...",
    image: null,
  },
  {
    title: "Contact Centre Remediation & Uplift",
    description:
      "Ongoing optimisation, innovation, and managed support for existing Amazon Connect environments - maximising ROI, client retention ...",
    image: null,
  },
  {
    title: "AI-First Contact Centre Modernisation",
    description:
      "Transform legacy or basic IVR into a conversational, AI-powered entry point—enabling natural language, faster intent resolution ...",
    image: null,
  },
  {
    title: "AI-Powered Self-Service & Automation",
    description:
      "Deploy a branded, GenAI-powered digital concierge to automate customer support and user journeys - across web, app, and contact centre ...",
    image: null,
  },
  {
    title: "Custom AI/ML & Reporting - Advanced Analytics for Contact Centres",
    description:
      "Transform legacy or basic IVR into a conversational, AI-powered entry point—enabling natural language, faster intent resolution ...",
    image: null,
  },
];
